var setting = "https://shopfront-cdn.tekoapis.com/static/e9b67a3d2e93b5be.svg";

export { setting as default };
